var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40167_4724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.0808 2.51773V25.5305",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5872 14.0241H47.5745",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.923 101.828V136.288",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.149 119.062H164.698",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7276 195.343C86.8085 194.007 74.2723 191.216 61.234 186.994C24.417 175.088 -2.4681 156.288 1.18296 144.994C2.52764 140.841 7.82126 138.279 15.8127 137.301",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.757 168.135C130.911 175.462 136.255 182.671 134.494 188.118C133.285 191.845 128.902 194.288 122.238 195.462",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.098 35.7092C149.268 22.7901 164.749 17.3177 177.668 23.4879C190.587 29.6581 196.06 45.139 189.889 58.0581C183.719 70.9773 168.238 76.4496 155.319 70.2794",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1915 91.7773C60.8553 91.7773 68.6894 83.9432 68.6894 74.2794C68.6894 64.6156 60.8553 56.7816 51.1915 56.7816C41.5277 56.7816 33.6936 64.6156 33.6936 74.2794C33.6936 83.9432 41.5277 91.7773 51.1915 91.7773Z",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.451 135.284C105.046 135.284 110.391 129.938 110.391 123.343C110.391 116.749 105.046 111.403 98.451 111.403C91.8565 111.403 86.5106 116.749 86.5106 123.343C86.5106 129.938 91.8565 135.284 98.451 135.284Z",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.153 127.42C115.523 132.041 113.004 135.939 109.472 138.441",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.817 51.156L106.477 50.8411C99.8128 49.939 93.7447 54.7645 93.1234 61.4624L90.6043 88.7901C90.0255 95.0879 94.5106 100.73 100.774 101.582C107.047 102.433 112.868 98.1943 113.991 91.9645L118.851 64.9518C120.043 58.339 115.481 52.0582 108.817 51.156Z",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.604 103.769C117.362 102.067 119.404 99.2411 120.017 95.8114L124.877 68.7986",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.698 112.016L131.251 27.59C124.791 11.2922 102.587 9.18154 93.166 23.9645L72.2723 56.773",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3532 99.0539L28.9532 124.807C20 138.867 29.7873 157.326 46.4511 157.811L151.821 160.85C167.243 161.292 178.094 145.82 172.409 131.471L170.026 125.454",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.685 170.782L159.94 171.479C171.668 171.82 180.757 162.943 181.932 152.365",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40167_4724"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 194.647,
    fill: "white",
    transform: "translate(0 1.66666)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorDark);
export default __webpack_public_path__ + "static/media/error-dark.70278c8afa6296ee8728cf733ca64085.svg";
export { ForwardRef as ReactComponent };